import {RouteNames} from "./consts";

import {LoginPage} from "../pages/LoginPage/LoginPage";
import {HomePage} from "../pages/HomePage/HomePage";
import {DocumentUploadPage} from "../pages/DocumentUploadPage/DocumentUploadPage";
import {UsersPage} from "../pages/UsersPage/UsersPage";
import NormativeDocumentsTreePage from "../pages/NormativeDocumentsTreePage/NormativeDocumentsTreePage.jsx";
import {ActPage} from "../pages/ActPage/ActPage";
import MobileDevicesPage from "../pages/MobileDevicesPage/MobileDevicesPage.jsx";
import ProfilePage from "../pages/ProfilePage/ProfilePage";
import NormativeDocumentEditPage from "../pages/NormativeDocumentEditPage/NormativeDocumentEditPage.jsx";
import {NotFoundPage} from "../pages/NotFoundPage/NotFoundPage";
import ProjectsPage from "../pages/ProjectsPage/ProjectsPage.jsx";
import ProjectEditPage from "../pages/ProjectEditPage/ProjectEditPage.jsx";
import LibraryPage from "../pages/LibraryPage/LibraryPage.jsx";
import ChartPage from "../pages/ChartPage/ChartPage";
import ChartDetailPage from "../pages/ChartDetailPage/ChartDetailPage";
import { PodrAdminPage } from "../pages/PodrAdmin/PodrAdmin";
import { ChartDeepAnalitics, ChartDeepAnaliticsPage } from "../pages/ChartDeepAnaliticsPage/ChartDeepAnalitics";
import { DataLensPage } from "../pages/DataLens/DataLensPage.jsx";
import { TestsPage } from "../pages/Tests/TestsPage.jsx";

export const publicRoutes = [
    {component: LoginPage, path: RouteNames.LOGIN, exact: true}
]

export const privateRoutesSupervisor = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
    {component: TestsPage, path: RouteNames.TESTS, exact: true},
]

export const privateRoutesProjectManager = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: ChartPage, path: RouteNames.CHART_PAGE, exact: true},
    {component: ChartDetailPage, path: RouteNames.CHART_DETAIL, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
]

export const privateRoutesEmployer = [
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: ChartPage, path: RouteNames.CHART_PAGE, exact: true},
    {component: ChartDetailPage, path: RouteNames.CHART_DETAIL, exact: true},
    {component: PodrAdminPage, path: RouteNames.PODR_PAGE, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
]

export const privateRoutesEmployerAdditional = [
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: ChartPage, path: RouteNames.CHART_PAGE, exact: true},
    {component: ChartDetailPage, path: RouteNames.CHART_DETAIL, exact: true},
    {component: PodrAdminPage, path: RouteNames.PODR_PAGE, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
]

export const privateRoutesModerator = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
]

export const privateRoutesContractor = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
]

export const privateRoutesSafetyEngineer = [
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: DocumentUploadPage, path: RouteNames.DOCUMENT_UPLOAD, exact: true},
    {component: NormativeDocumentsTreePage, path: RouteNames.NORMATIVE_DOCUMENTS, exact: true},
    {component: NormativeDocumentEditPage, path: RouteNames.NORMATIVE_DOCUMENT_EDIT, exact: true},
    {component: ProjectsPage, path: RouteNames.PROJECTS, exact: true},
    {component: ProjectEditPage, path: RouteNames.PROJECT_EDIT, exact: true},
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
]

export const privateRoutes = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
]

export const privateRoutesProjectEditor = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: ChartPage, path: RouteNames.CHART_PAGE, exact: true},
    {component: ChartDetailPage, path: RouteNames.CHART_DETAIL, exact: true},
    {component: PodrAdminPage, path: RouteNames.PODR_PAGE, exact: true},
    {component: ChartDeepAnaliticsPage, path: RouteNames.CHART_DEEP_ANALITICS, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
]

export const privateRoutesFieldContractor = [
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
]

export const adminRoutes = [
    {component: ActPage, path: RouteNames.CREATE_ACT, exact: true},
    {component: ActPage, path: RouteNames.ACT, exact: true},
    {component: LibraryPage, path: RouteNames.LIBRARY, exact: true},
    {component: HomePage, path: RouteNames.HOME, exact: true},
    {component: UsersPage, path: RouteNames.USERS, exact: true},
    {component: DocumentUploadPage, path: RouteNames.DOCUMENT_UPLOAD, exact: true},
    {component: NormativeDocumentsTreePage, path: RouteNames.NORMATIVE_DOCUMENTS, exact: true},
    {component: NormativeDocumentEditPage, path: RouteNames.NORMATIVE_DOCUMENT_EDIT, exact: true},
    {component: MobileDevicesPage, path: RouteNames.DEVICES, exact: true},
    {component: ProfilePage, path: RouteNames.PROFILE, exact: true},
    {component: ProjectsPage, path: RouteNames.PROJECTS, exact: true},
    {component: ProjectEditPage, path: RouteNames.PROJECT_EDIT, exact: true},
    {component: ChartPage, path: RouteNames.CHART_PAGE, exact: true},
    {component: ChartDetailPage, path: RouteNames.CHART_DETAIL, exact: true},
    {component: PodrAdminPage, path: RouteNames.PODR_PAGE, exact: true},
    {component: ChartDeepAnaliticsPage, path: RouteNames.CHART_DEEP_ANALITICS, exact: true},
    {component: DataLensPage, path: RouteNames.DATA_LENS, exact: true},
    {component: TestsPage, path: RouteNames.TESTS, exact: true},
]

export const notFoundRoute = {
    component: NotFoundPage,
    path: RouteNames.NOT_FOUND,
    exact: true
}
